// import React, { useEffect, useState } from "react";
// import { Box, Paper, Grid, Typography, Chip } from "@mui/material";
// import img2 from "../../assests/indiaImages/player.jpeg";
// import { useDispatch, useSelector } from "react-redux";
// import { Actions } from "../../redux/Actions/Actions";
// import { ErrorToast } from "../Toast/message";
// import { getAllBetData } from "../../Utility/API";
// import Loader from "../Loader";
// import { sportEndPoint } from "../../constant/Environment";
// import moment from "moment-timezone";
// import { Link } from "react-router-dom";
// import { useSnackbarContext } from "../SnackbarContext";

// const PlayerPage = () => {
//   const [counter, setcounter] = useState(1);
//   const dispatch = useDispatch();
//   const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();
//   const state = useSelector((state) => state);
//   const { selectedBetslipBtn } = state.betslip;
//   const [playersData, setPlayersData] = useState([]);
//   const [matchData, setMatchData] = useState([]);
//   const [isLoading, setIsLoadinig] = useState(false);
//   const [teamSize, setTeamSize] = useState(0);

//   const players = [
//     {
//       name: "Joe Root",
//       _id: 11,
//       Position: "Bat",
//       team: "Eng vs Ind",
//       Points: "10.5",
//       team:"Away",
//       player_id:1,
//     },
//     {
//       name: "Virat Kholi",
//       _id: 12,
//       Position: "Bat",
//       team: "Eng vs Ind",
//       Points: "11",
//       team:"Home",
//       player_id:2,
//     },
//      {
//       name: "Rishabh Pant",
//       _id: 19,
//       Position: "Bat",
//       team: "Eng vs Ind",
//       Points: "11",
//       team:"Home",
//       player_id:3,
//     },
//     {
//       name: "Rohit Sharma",
//       Position: "Bat",
//       _id: 13,
//       team: "Eng vs Ind",
//       Points: "11",
//       team:"Home",
//       player_id:4,
//     },
//   ];

//   const betslipLength = state.betslip.betslips.length;

//   const fetchPlayers = async (poolId) => {
//       setIsLoadinig(true);
//       try {
//         const url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.PLAYER_DATA}/${poolId}`;
//         const playerValues = await getAllBetData(url);
//         setIsLoadinig(false);

//         const home = Array.isArray(playerValues.homePlayers) ? playerValues.homePlayers : [];
//         const away = Array.isArray(playerValues.awayPlayers) ? playerValues.awayPlayers : [];
//         const allPlayers = [...home, ...away]; // even if both are empty, this will be []

//         setPlayersData(allPlayers);
//         setMatchData(playerValues);
//       } catch (error) {
//         console.error("Failed to fetch pool data:", error);
//       } finally {
//         setIsLoadinig(false);
//       }
//     };

//     useEffect(() => {
//       let params = new URLSearchParams(window.location.search);
//       let poolId = params.get("poolId") || "";
//       if (poolId) {
//         fetchPlayers(poolId);
//       }
//     }, []);

//     useEffect(()=>{
//        setTeamSize(state.betslip.pooldata.teamSize)
//     },[])

//   const handlechangePlayer = (element, playerId, btnName, index,Team,teamSize) => {
//     const alreadySelected = state.betslip.betslips?.some(
//       (item) => item.playerId == playerId
//     );

//     if (alreadySelected) {
//       dispatch({
//         type: Actions.REMOVE_SELECTED_BETSLIP,
//         data: playerId,
//       });
//       return;
//     } else {
//     if(state.betslip.betslips?.length >= teamSize){
//       showErrorSnackbar(`You cannot select more than ${teamSize} players in your team`);
//       return;
//     }
//       dispatch({
//         type: Actions.SELECTED_BETSLIP,
//         data: {
//           ...element,
//           displayName: "",
//           isMore: false,
//           isLess: false,
//           playerId,
//           Team,
//           isShowing: false,
//           teamSize,
//         },
//         selectedBtn: btnName,
//       });
//     }
//   };

//   return (
//     <>
//     {isLoading && <Loader visible={isLoading} />}
//     <Grid sx={{ width: "100%", marginBottom: "15px" }}>
//       <Paper
//         elevation={3}
//         sx={{
//           border: "1px solid white",
//           borderRadius: "5px",
//           padding: "10px",
//           background: "whitesmoke",
//         }}
//       >
//         <Box
//           sx={{
//             maxHeight: "720px",
//             overflowY: "auto",
//             // Hide scrollbar in WebKit browsers
//             "&::-webkit-scrollbar": {
//               width: "6px",
//             },
//             "&::-webkit-scrollbar-track": {
//               background: "transparent",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               backgroundColor: "transparent",
//             },
//             // Optional: Firefox
//             scrollbarWidth: "none", // for Firefox
//             "&": {
//               msOverflowStyle: "none", // IE and Edge
//               scrollbarWidth: "none", // Firefox again
//             },
//           }}
//         >
//           <Box
//             display="flex"
//             justifyContent="space-between"
//             alignItems="center"
//             mb={2}
//             sx={{
//               fontSize: "15px",
//               color: "#666",
//               borderBottom: "1px solid black",
//               padding: "4px",
//             }}
//           >
//             <Typography variant="body2">
//               {/* {"IND vs ENG"} */}
//               {matchData?.eventName}
//             </Typography>
//             <Typography variant="body2">{moment(matchData?.startDate).format("ddd, MMM D, h:mm A")}</Typography>
//           </Box>
//           <Box
//             display="flex"
//             justifyContent="space-between"
//             // alignItems="center"
//             mb={2}
//             sx={{
//               borderBottom: "1px solid #e0e0e0", // Added a border
//               paddingBottom: 1, // Added padding
//             }}
//           >
//             <Box display="flex" alignItems="center" gap={1}>
//               <Chip label="Home" size="small" color="primary" />
//               <Typography variant="h6" fontWeight="bold" sx={{fontSize:{xs:"15px",md:"18px"}}}>
//                 {matchData?.teamH?.name}
//               </Typography>
//             </Box>
//             <Typography variant="body1" fontWeight="bold">
//               vs
//             </Typography>
//             <Box display="flex" alignItems="center" gap={1}>
//               <Typography variant="h6" fontWeight="bold" sx={{fontSize:{xs:"15px",md:"18px"},textAlign:"end"}}>
//                 {matchData?.teamA?.name}
//               </Typography>
//               <Chip label="Away" size="small" color="primary" />
//             </Box>
//           </Box>
//           <Grid container spacing={2} sx={{ width: "100%" }}>
//             {playersData?.map((player, index) => {
//               let btn11Name = `${player?.player_id}_btn11`;
//               const isSelected = selectedBetslipBtn.includes(btn11Name);
//               return (
//                 <Grid
//                   item
//                   xs={12}
//                   md={6}
//                   key={index}
//                   sx={{ width: { xs: "100%", md: "48%" } }}
//                 >
//                   <Paper
//                     elevation={2}
//                     sx={{
//                       display: "flex",
//                       justifyContent: "space-evenly",
//                       cursor: "pointer",
//                       alignItems: "center",
//                       padding: "10px",
//                       width: "100%",
//                       background: isSelected ? "whitesmoke" : "white",
//                       borderRadius: 2,
//                       border: isSelected
//                         ? "3px solid green"
//                         : "1px solid #0D3862",
//                       overflow: "hidden",
//                     }}
//                     onClick={() => {
//                       handlechangePlayer(player, player.player_id, btn11Name, index,player?.teamType,teamSize);
//                     }}
//                   >
//                     {/* Left Side - Image */}
//                     <Box
//                       component="img"
//                       src={player.image?player.image:img2}
//                       alt={player.name}
//                       sx={{
//                         width: 80,
//                         height: 80,
//                         objectFit: "cover",
//                         borderRadius: "8px",
//                         flexShrink: 0,
//                       }}
//                     />

//                     {/* Right Side - Info */}
//                     <Box
//                       sx={{
//                         //   ml: 3,
//                         display: "flex",
//                         flexDirection: "column",
//                         justifyContent: "center",
//                       }}
//                     >
//                       {/* <Typography variant="body1" textAlign={"center"}>{player.name}</Typography>
//                     <Typography variant="body2" textAlign={"center"} color="text.secondary">
//                       {player.Position} | {player.team}
//                     </Typography>
//                     <Typography variant="body2" textAlign={"center"}>
//                       <strong>Credit Points:</strong> {player.Points}
//                     </Typography> */}

//                       <Typography
//                         variant="body1"
//                         sx={{
//                           color: "#C02640!important",
//                           textAlign: "center",
//                           fontWeight: "700",
//                         }}
//                       >
//                         {player.name}
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "#0D3862!important", textAlign: "center" }}
//                       >
//                         <span style={{ color: "##C02640!important" }}>
//                           {player.positionAbv}
//                         </span>{" "}
//                         | {player.teamType}
//                       </Typography>
//                       <Typography
//                         variant="body2"
//                         sx={{ color: "#0D3862!important", textAlign: "center" }}
//                       >
//                         <strong>Credit Points:</strong> {player.fantasypoint}
//                       </Typography>
//                     </Box>
//                   </Paper>
//                 </Grid>
//               );
//             })}
//           </Grid>
//         </Box>
//       </Paper>

//       {window.location.pathname !== "/MobileBetSlip" && betslipLength > 0 && (
//   <Link to="/MobileBetSlip" style={{ textDecoration: "none" }}>
//     <Box
//       sx={{
//         position: "fixed",
//         bottom: 60,
//         left: 0,
//         width: "100%",
//         zIndex: 1300, // higher than app bar, modals, etc.
//         bgcolor: betslipLength==teamSize?"green":"grey",
//         color: "#fff",
//         p: 1,
//         display:{xs:"block",md:"none"}
//       }}
//     >
//       {betslipLength==teamSize ?
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         px={2}
//       >
//         <Typography variant="h6">
//           Team Completed
//         </Typography>
//         <Typography fontWeight={600} sx={{ fontSize: "18px", color: "white" }}>
//           Finalize{" "}
//           <i className="fa fa-angle-double-up" style={{ fontSize: 17 }} />
//         </Typography>
//       </Box>
//       :
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         px={2}
//       >
//         <Typography variant="h6">
//           <b>{betslipLength}</b> player selected
//         </Typography>
//       </Box>
//     }
//     </Box>
//   </Link>
// )}

//     </Grid>
//     </>
//   );
// };

// export default PlayerPage;

import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Chip,
  Stack,
  ButtonBase,
  Button,
  Avatar,
  Divider,
  Tooltip,
  Skeleton,
} from "@mui/material";
import img2 from "../../assests/indiaImages/player.jpeg";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { ErrorToast } from "../Toast/message";
import { getAllBetData } from "../../Utility/API";
import Loader from "../Loader";
import { sportEndPoint } from "../../constant/Environment";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { useSnackbarContext } from "../SnackbarContext";
import SportsCricketOutlinedIcon from "@mui/icons-material/SportsCricketOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const PlayerPage = () => {
  const [counter, setcounter] = useState(1);
  const dispatch = useDispatch();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();
  const state = useSelector((state) => state);
  const { selectedBetslipBtn } = state.betslip;
  const [homeTeamPlayers, setHomeTeamPlayers] = useState([]);
  const [awayTeamPlayers, setAwayTeamPlayers] = useState([]);
  const [matchData, setMatchData] = useState([]);
  const [isLoading, setIsLoadinig] = useState(false);
  const [teamSize, setTeamSize] = useState(0);

  const betslipLength = state.betslip.betslips.length;

  const fetchPlayers = async (poolId) => {
    setIsLoadinig(true);
    try {
      const url = `${sportEndPoint.apiBaseUrl}${sportEndPoint.api.PLAYER_DATA}/${poolId}`;
      const playerValues = await getAllBetData(url);
      setIsLoadinig(false);

      const home = Array.isArray(playerValues.homePlayers)
        ? playerValues.homePlayers
        : [];
      const away = Array.isArray(playerValues.awayPlayers)
        ? playerValues.awayPlayers
        : [];
      const allPlayers = [...home, ...away]; // even if both are empty, this will be []
      setHomeTeamPlayers(home);
      setAwayTeamPlayers(away);
      setMatchData(playerValues);
    } catch (error) {
      console.error("Failed to fetch pool data:", error);
    } finally {
      setIsLoadinig(false);
    }
  };

  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    let poolId = params.get("poolId") || "";
    if (poolId) {
      fetchPlayers(poolId);
    }
  }, []);

  useEffect(() => {
    setTeamSize(state.betslip.pooldata.teamSize);
  }, []);

  const handlechangePlayer = (
    element,
    playerId,
    btnName,
    index,
    Team,
    teamSize
  ) => {
    const alreadySelected = state.betslip.betslips?.some(
      (item) => item.playerId == playerId
    );

    if (alreadySelected) {
      dispatch({
        type: Actions.REMOVE_SELECTED_BETSLIP,
        data: playerId,
      });
      return;
    } else {
      if (state.betslip.betslips?.length >= teamSize) {
        showErrorSnackbar(
          `You cannot select more than ${teamSize} players in your team`
        );
        return;
      }
      dispatch({
        type: Actions.SELECTED_BETSLIP,
        data: {
          ...element,
          displayName: "",
          isMore: false,
          isLess: false,
          playerId,
          Team,
          isShowing: false,
          teamSize,
        },
        selectedBtn: btnName,
      });
    }
  };

  const reloadPlayers = () => {
    const params = new URLSearchParams(window.location.search);
    const poolId = params.get("poolId") || "";
    if (poolId) fetchPlayers(poolId);
  };

  return (
    <>
      {/* {isLoading && <Loader visible={isLoading} />} */}
      <Grid sx={{ width: "100%", marginBottom: "15px" }}>
        <Paper
          elevation={3}
          sx={{
            border: "1px solid white",
            borderRadius: "5px",
            padding: "10px",
            background: "whitesmoke",
          }}
        >
          <Box
            sx={{
              maxHeight: "720px",
              overflowY: "auto",
              // Hide scrollbar in WebKit browsers
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "transparent",
              },
              // Optional: Firefox
              scrollbarWidth: "none", // for Firefox
              "&": {
                msOverflowStyle: "none", // IE and Edge
                scrollbarWidth: "none", // Firefox again
              },
            }}
          >
            {isLoading ? (
              <>
                {/* Header skeleton */}
                <Skeleton
                  variant="rectangular"
                  height={44}
                  sx={{ mb: 2, borderRadius: 2 }}
                />

                {/* Home/Away strip skeleton */}
                <Skeleton
                  variant="rectangular"
                  height={36}
                  sx={{ mb: 2, borderRadius: 1 }}
                />

                {/* Player card skeleton grid */}
                <Grid container spacing={2} sx={{ width: "100%" }}>
                  {[...Array(6)].map((_, i) => (
                    <Grid
                      item
                      xs={12}
                      md={6}
                      key={i}
                      sx={{ width: { xs: "100%", md: "48%" } }}
                    >
                      <Paper
                        elevation={1}
                        sx={{
                          p: 1.25,
                          width: "100%",
                          borderRadius: 2,
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <Stack
                          direction="row"
                          spacing={1.5}
                          alignItems="center"
                        >
                          <Skeleton
                            variant="rounded"
                            width={64}
                            height={64}
                            sx={{ borderRadius: 1 }}
                          />
                          <Box flex={1} minWidth={0}>
                            <Skeleton variant="text" width="60%" height={20} />
                            <Stack direction="row" spacing={1} sx={{ mt: 0.5 }}>
                              <Skeleton
                                variant="rounded"
                                width={64}
                                height={24}
                              />
                              <Skeleton
                                variant="rounded"
                                width={64}
                                height={24}
                              />
                            </Stack>
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                              sx={{ mt: 1 }}
                            >
                              <Skeleton
                                variant="circular"
                                width={18}
                                height={18}
                              />
                              <Skeleton
                                variant="text"
                                width={100}
                                height={18}
                              />
                            </Stack>
                          </Box>
                          <Skeleton variant="circular" width={28} height={28} />
                        </Stack>
                      </Paper>
                    </Grid>
                  ))}
                </Grid>
              </>
            ) : (
              <>
                <Box
                  sx={{
                    mb: 2,
                    p: 1,
                    borderRadius: 2,
                    background:
                      "linear-gradient(90deg, #0D3862 0%, #0a4a7a 60%, #0d3862 100%)",
                    color: "#fff",
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={2}
                  >
                    <Stack direction="row" spacing={1.2} alignItems="center">
                      <SportsCricketOutlinedIcon fontSize="small" />
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 800, letterSpacing: 0.3 }}
                      >
                        {matchData?.eventName || "Match"}
                      </Typography>
                    </Stack>
                    <Typography variant="caption" sx={{ opacity: 0.9 }}>
                      {moment(matchData?.startDate).format(
                        "ddd, MMM D, h:mm A"
                      )}
                    </Typography>
                  </Stack>
                </Box>

                {homeTeamPlayers?.length === 0 && awayTeamPlayers.length === 0 ? (
                  <Paper
                    elevation={0}
                    sx={{
                      p: 4,
                      borderRadius: 2,
                      border: "1px dashed #b0bec5",
                      bgcolor: "#fafcff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: 220,
                      textAlign: "center",
                    }}
                  >
                    <Stack spacing={1.5} alignItems="center">
                      <SportsCricketOutlinedIcon
                        sx={{ fontSize: 36, color: "#90a4ae" }}
                      />
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        No players available
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ maxWidth: 420 }}
                      >
                        We can’t find active players for this matchup right now.
                        They might be announced closer to start time.
                      </Typography>
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1}
                        sx={{ mt: 0.5 }}
                      >
                        <Button
                          variant="contained"
                          onClick={reloadPlayers}
                          sx={{ textTransform: "none" }}
                        >
                          Refresh list
                        </Button>
                        <Button
                          variant="text"
                          onClick={() => window.history.back()}
                          sx={{ textTransform: "none" }}
                        >
                          Go back
                        </Button>
                      </Stack>
                    </Stack>
                  </Paper>
                ) : (
                  <Grid container spacing={2} sx={{ width: "100%" }}>
                    <Grid
                      item
                      md={6}
                      sx={{ mb: 1, width: { xs: "100%", md: "48%" } }}
                    >
                      {homeTeamPlayers?.map((player, index) => {
                        let btn11Name = `${player?.player_id}_btn11`;
                        const isSelected =
                          selectedBetslipBtn.includes(btn11Name);
                        return (
                          <Grid
                            item
                            xs={12}
                            md={12}
                            key={index}
                            sx={{ width: { xs: "100%", md: "100%" }, mb: 2 }}
                          >
                            <ButtonBase
                              onClick={() => {
                                handlechangePlayer(
                                  player,
                                  player.player_id,
                                  btn11Name,
                                  index,
                                  player?.teamType,
                                  teamSize
                                );
                              }}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                borderRadius: 2,
                                display: "block",
                              }}
                            >
                              <Paper
                                elevation={isSelected ? 4 : 1}
                                sx={{
                                  p: 1.25,
                                  width: "100%",
                                  borderRadius: 2,
                                  border: isSelected
                                    ? "2px solid #2e7d32"
                                    : "1px solid #0D3862",
                                  backgroundColor: "#fff",
                                  transition:
                                    "transform .2s ease, box-shadow .2s ease",
                                  "&:hover": {
                                    transform: "translateY(-2px)",
                                    boxShadow: 4,
                                  },
                                }}
                              >
                                <Stack
                                  direction="row"
                                  spacing={1.5}
                                  alignItems="center"
                                >
                                  <Avatar
                                    src={player.image ? player.image : img2}
                                    alt={player.name}
                                    variant="rounded"
                                    sx={{
                                      width: 64,
                                      height: 64,
                                      borderRadius: 1,
                                    }}
                                  />
                                  <Box flex={1} minWidth={0}>
                                    <Typography
                                      variant="subtitle1"
                                      sx={{
                                        color: "#C02640",
                                        fontWeight: 800,
                                        lineHeight: 1.1,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {player.name}
                                    </Typography>
                                    <Stack
                                      direction="row"
                                      spacing={1}
                                      alignItems="center"
                                      sx={{ mt: 0.25, flexWrap: "wrap" }}
                                    >
                                      <Chip
                                        size="small"
                                        variant="outlined"
                                        label={player.positionAbv || "—"}
                                      />
                                      <Chip
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        label={player.teamType || "—"}
                                      />
                                    </Stack>
                                    <Stack
                                      direction="row"
                                      spacing={1}
                                      alignItems="center"
                                      sx={{ mt: 0.75 }}
                                    >
                                      <EmojiEventsOutlinedIcon fontSize="small" />
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                      >
                                        {" "}
                                         Projected Points{" "}:
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        sx={{ fontWeight: 800 }}
                                      >
                                        {player.fantasypoint ?? "—"}
                                      </Typography>
                                    </Stack>
                                  </Box>
                                  <Tooltip
                                    title={
                                      isSelected ? "Selected" : "Tap to select"
                                    }
                                    placement="left"
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {isSelected ? (
                                        <CheckCircleRoundedIcon color="success" />
                                      ) : (
                                        <RadioButtonUncheckedIcon
                                          sx={{ color: "#90a4ae" }}
                                        />
                                      )}
                                    </Box>
                                  </Tooltip>
                                </Stack>
                              </Paper>
                            </ButtonBase>
                          </Grid>
                        );
                      })}
                    </Grid>

                    <Grid
                      item
                      md={6}
                      sx={{ mb: 1, width: { xs: "100%", md: "48%" } }}
                    >
                      {awayTeamPlayers?.map((player, index) => {
                        let btn11Name = `${player?.player_id}_btn11`;
                        const isSelected =
                          selectedBetslipBtn.includes(btn11Name);
                        return (
                          <Grid
                            item
                            xs={12}
                            md={12}
                            key={index}
                            sx={{ width: { xs: "100%", md: "100%" }, mb: 2 }}
                          >
                            <ButtonBase
                              onClick={() => {
                                handlechangePlayer(
                                  player,
                                  player.player_id,
                                  btn11Name,
                                  index,
                                  player?.teamType,
                                  teamSize
                                );
                              }}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                borderRadius: 2,
                                display: "block",
                              }}
                            >
                              <Paper
                                elevation={isSelected ? 4 : 1}
                                sx={{
                                  p: 1.25,
                                  width: "100%",
                                  borderRadius: 2,
                                  border: isSelected
                                    ? "2px solid #2e7d32"
                                    : "1px solid #0D3862",
                                  backgroundColor: "#fff",
                                  transition:
                                    "transform .2s ease, box-shadow .2s ease",
                                  "&:hover": {
                                    transform: "translateY(-2px)",
                                    boxShadow: 4,
                                  },
                                }}
                              >
                                <Stack
                                  direction="row"
                                  spacing={1.5}
                                  alignItems="center"
                                >
                                  <Avatar
                                    src={player.image ? player.image : img2}
                                    alt={player.name}
                                    variant="rounded"
                                    sx={{
                                      width: 64,
                                      height: 64,
                                      borderRadius: 1,
                                    }}
                                  />
                                  <Box flex={1} minWidth={0}>
                                    <Typography
                                      variant="subtitle1"
                                      sx={{
                                        color: "#C02640",
                                        fontWeight: 800,
                                        lineHeight: 1.1,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {player.name}
                                    </Typography>
                                    <Stack
                                      direction="row"
                                      spacing={1}
                                      alignItems="center"
                                      sx={{ mt: 0.25, flexWrap: "wrap" }}
                                    >
                                      <Chip
                                        size="small"
                                        variant="outlined"
                                        label={player.positionAbv || "—"}
                                      />
                                      <Chip
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                        label={player.teamType || "—"}
                                      />
                                    </Stack>
                                    <Stack
                                      direction="row"
                                      spacing={1}
                                      alignItems="center"
                                      sx={{ mt: 0.75 }}
                                    >
                                      <EmojiEventsOutlinedIcon fontSize="small" />
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                      >
                                        {" "}
                                         Projected Points{" "}:
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        sx={{ fontWeight: 800 }}
                                      >
                                        {player.fantasypoint ?? "—"}
                                      </Typography>
                                    </Stack>
                                  </Box>
                                  <Tooltip
                                    title={
                                      isSelected ? "Selected" : "Tap to select"
                                    }
                                    placement="left"
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {isSelected ? (
                                        <CheckCircleRoundedIcon color="success" />
                                      ) : (
                                        <RadioButtonUncheckedIcon
                                          sx={{ color: "#90a4ae" }}
                                        />
                                      )}
                                    </Box>
                                  </Tooltip>
                                </Stack>
                              </Paper>
                            </ButtonBase>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                )}
              </>
            )}
          </Box>
        </Paper>

        {window.location.pathname !== "/MobileBetSlip" && betslipLength > 0 && (
          <Link to="/MobileBetSlip" style={{ textDecoration: "none" }}>
            <Box
              sx={{
                position: "fixed",
                bottom: 60,
                left: 0,
                width: "100%",
                zIndex: 1300, // higher than app bar, modals, etc.
                bgcolor: betslipLength == teamSize ? "green" : "grey",
                color: "#fff",
                p: 1,
                display: { xs: "block", md: "none" },
              }}
            >
              {betslipLength == teamSize ? (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  px={2}
                >
                  <Typography variant="h6">Team Completed</Typography>
                  <Typography
                    fontWeight={600}
                    sx={{ fontSize: "18px", color: "white" }}
                  >
                    Finalize{" "}
                    <i
                      className="fa fa-angle-double-up"
                      style={{ fontSize: 17 }}
                    />
                  </Typography>
                </Box>
              ) : (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  px={2}
                >
                  <Typography variant="h6">
                    <b>{betslipLength}</b> player selected
                  </Typography>
                </Box>
              )}
            </Box>
          </Link>
        )}
      </Grid>
    </>
  );
};

export default PlayerPage;
